/**
 * RESPONSIBILITY: the channel's newest videos that have not been entered as sermons yet.
 *
 * Entering a sermon takes a few minutes nobody may have on a Sunday. Until it is
 * done, last Sunday's video still appears here, straight from YouTube, so the page is
 * never a week behind the channel (decision 2026-10-17). The moment a sermon with that
 * video's link is entered, the video leaves this strip — it is never shown twice.
 *
 * With NO sermons entered yet it draws nothing: the list above is YouTube's videos then
 * (see SermonFinder), and a second copy of them here would say the same thing twice.
 */
import type { SermonRow, SermonsSection } from '@app/sections';
import { VideoPlayer, YoutubeThumb, useLatestSermons, youtubeId } from '../commons';

export function SermonsYoutube({ c, sermons }: { c: SermonsSection; sermons: readonly SermonRow[] }) {
  const entered = new Set(sermons.map((s) => youtubeId(s.youtubeUrl)).filter(Boolean));
  const fresh = useLatestSermons().filter((v) => !entered.has(v.videoId)).slice(0, 3);
  if (sermons.length === 0 || !c.youtubeHeading || fresh.length === 0) return null;

  return (
    <section className="band band-tint">
      <div className="wrap">
        <div className="band-head"><h2>{c.youtubeHeading}</h2></div>
        <div className="sermon-grid">
          {fresh.map((v) => (
            <div className="sermon-live" key={v.videoId}>
              <VideoPlayer
                url={v.url} title={v.title} className="sermon-video"
                picture={<YoutubeThumb url={v.url} alt={v.title} />}
              />
              <h3 className="sermon-title">{v.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
